import { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import logo from '../assets/about/Landmark Construction Logo.png';
import ThemeToggle from './ThemeToggle';
import { scrollToTopNow } from './ScrollToTop';
import './Navbar.css';

const links = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About' },
  { to: '/services', label: 'Services' },
  { to: '/projects', label: 'Projects' },
  { to: '/blog', label: 'Blog' },
  { to: '/privacy', label: 'Privacy Policy' },
  { to: '/terms', label: 'Terms & Conditions' },
];

function pathMatches(pathname, to) {
  if (to === '/') return pathname === '/';
  return pathname === to || pathname.startsWith(`${to}/`);
}

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!menuOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [menuOpen]);

  const handleNavClick = (to) => {
    setMenuOpen(false);
    if (pathMatches(location.pathname, to)) {
      scrollToTopNow(true);
    }
  };

  return (
    <header className="site-header">
      <div className="site-header-inner">
        <NavLink to="/" className="brand" end onClick={() => handleNavClick('/')}>
          <img src={logo} alt="Landmarks Construction" className="brand-logo" width={355} height={207} />
        </NavLink>

        <nav className={`site-nav ${menuOpen ? 'site-nav--open' : ''}`} id="main-nav" aria-label="Main">
          <ul>
            {links.map(({ to, label }) => (
              <li key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
                  end={to === '/'}
                  onClick={() => handleNavClick(to)}
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="site-header-end">
          <ThemeToggle />
          <NavLink
            to="/contact"
            className={({ isActive }) => (isActive ? 'nav-contact-btn active' : 'nav-contact-btn')}
            onClick={() => handleNavClick('/contact')}
          >
            Contact
          </NavLink>
          <button
            type="button"
            className={`nav-toggle ${menuOpen ? 'nav-toggle--open' : ''}`}
            onClick={() => setMenuOpen((o) => !o)}
            aria-expanded={menuOpen}
            aria-controls="main-nav"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          >
            <span className="nav-toggle-bar" aria-hidden />
            <span className="nav-toggle-bar" aria-hidden />
            <span className="nav-toggle-bar" aria-hidden />
          </button>
          <div className="site-header-balance" aria-hidden="true" />
        </div>
      </div>
      {menuOpen ? (
        <button
          type="button"
          className="nav-backdrop"
          aria-label="Close menu"
          onClick={() => setMenuOpen(false)}
        />
      ) : null}
    </header>
  );
}
